import * as React from "react";
import { StyledStep } from "../../../components/ReactTourSteps/ReactTourSteps.styles";

export const tourSteps = [
  {
    selector: ".step-1",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Search Filters</h1>
        <p className="step-text">I can identify which area an individual may need support in.
          Here I give you a cohort wide overview of how many learners fall into
          each area on the chart and provide a list of learners in that area.
        </p>
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
];



// WEBPACK FOOTER //
// ./src/pages/DataCenter/SearchFilters/SearchFiltersTour.tsx